import request from '@/request/request'

// 查询角色列表
export function listRole(query) {
    return request({
        url: '/api/permission/role/list',
        method: 'get',
        params: query
    })
}

// 查询角色详细
export function getRoleById(id) {
    return request({
        url: '/api/permission/role/' + id,
        method: 'get'
    })
}

// 新增角色
export function addRole(data) {
    return request({
        url: '/api/permission/role',
        method: 'post',
        data: data
    })
}

// 修改角色
export function updateRole(data) {
    return request({
        url: '/api/permission/role/edit',
        method: 'post',
        data: data
    })
}

// 删除角色
export function delRole(id) {
    return request({
        url: '/api/permission/role/delete/' + id,
        method: 'post'
    })
}

// 修改角色状态
export function changeRoleStatus(data) {
    return request({
        url: '/api/permission/role/changeStatus',
        method: 'post',
        data: data
    })
}

// 查询角色选择框
export function roleSelect() {
    return request({
        url: '/api/permission/role/optionselect',
        method: 'get',
    })
}

// 查询已授权用户列表
export function authUserList(query) {
    return request({
        url: '/api/permission/role/authUser/allocatedList',
        method: 'get',
        params: query
    })
}

// 批量取消授权
export function cancelAuthAll(query) {
    return request({
        url: '/api/permission/role/authUser/cancelAll',
        method: 'post',
        params: query
    })
}

// 取消授权用户
export function cancelAuth(data) {
    return request({
        url: '/api/permission/role/authUser/cancel',
        method: 'post',
        data: data
    })
}

// 查询未授权用户列表
export function unAuthUserList(query) {
    return request({
        url: '/api/permission/role/authUser/unallocatedList',
        method: 'get',
        params: query
    })
}

// 批量授权用户
export function selectAuthUserAll(query) {
    return request({
        url: '/api/permission/role/authUser/selectAll',
        method: 'post',
        params: query
    })
}